const getters = {
  // sidebar: state => state.app.sidebar,
  // token: state => state.user.token,
  // avatar: state => state.user.avatar,
  username: state => state.user.username,
  role: state => state.user.role,
  user_logo: state => state.user.user_logo,
  animal_types: state => state.app.animal_types,
  animal_genders: state => state.app.animal_genders,
  county_code_list: state => state.app.county_code_list,
  area_code_list: state => state.app.area_code_list,
  area_code_for_county: state => state.app.area_code_for_county,
}
export default getters
